import React from 'react';
import PropTypes from 'prop-types';

import { Header, Dropdown } from 'semantic-ui-react';

import './AnalyticsDayPicker.css';

const AnalyticsDayPicker = ({ options, handleDateSelect }) => (
  <div className="analytics-day-dicker__component">
    <Header as="h4">
      {' '}
      <Dropdown
        inline
        options={options}
        onChange={(_e, value) => { handleDateSelect(value); }}
        defaultValue={options[options.length - 1].value}
      />
    </Header>
  </div>
);

AnalyticsDayPicker.propTypes = {
  options: PropTypes.array,
  handleDateSelect: PropTypes.func,
};
AnalyticsDayPicker.defaultProps = {
  options: null,
  handleDateSelect: null,
};

export default AnalyticsDayPicker;
